var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.99805 16V8H12.998C13.5285 8 14.0372 8.21071 14.4123 8.58579C14.7873 8.96086 14.998 9.46957 14.998 10C14.998 10.5304 14.7873 11.0391 14.4123 11.4142C14.0372 11.7893 13.5285 12 12.998 12H8.99805M5.99805 4H17.998C19.1026 4 19.998 4.89543 19.998 6V18C19.998 19.1046 19.1026 20 17.998 20H5.99805C4.89348 20 3.99805 19.1046 3.99805 18V6C3.99805 4.89543 4.89348 4 5.99805 4Z", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});